import { Card, CardContent } from "~/components/reusable/Card"
import { Trophy } from "@phosphor-icons/react"
import { formatNumber } from "~/utils/formatting"
import {
  SimpleTable,
  SimpleTableBody,
  SimpleTableCell,
  SimpleTableHead,
  SimpleTableHeader,
  SimpleTableRow,
} from "~/components/reusable/Table"
import { useMemo } from "react"
import { sumBy } from "lodash"
import LoadingOverlay from "../../reusable/LoadingOverlay"
import { Separator } from "../../reusable/Separator"
import { formatName } from "~/utils/namingUtils"

type Props = {
  topProducts: { name: string; value: number }[]
  isLoading: boolean
}

const TopProductsCard = ({ topProducts, isLoading }: Props) => {
  const topProductsSum = useMemo(() => sumBy(topProducts, "value"), [topProducts])

  return (
    <Card className="w-full flex flex-col">
      <CardContent className="flex flex-col gap-3">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <Trophy className="text-fg-subtle" />
            <div className="label-base text-fg-subtle">Best sellers</div>
          </div>

          <div className="flex items-end gap-1">
            <div className="heading-sm">
              {topProductsSum ? formatNumber(topProductsSum, 0) : "-"}
            </div>
            <p className="paragraph-base pb-[2px]">Units</p>
          </div>
        </div>
      </CardContent>
      <Separator />
      <CardContent>
        <SimpleTable>
          <SimpleTableHeader>
            <SimpleTableRow className="text-left font-medium border-none text-fg-subtle">
              <SimpleTableHead>Product</SimpleTableHead>
              <SimpleTableHead>{formatName("preorder", true, true)}</SimpleTableHead>
            </SimpleTableRow>
          </SimpleTableHeader>
          <SimpleTableBody>
            {isLoading && (
              <SimpleTableRow>
                <SimpleTableCell colSpan={2}>
                  <LoadingOverlay />
                </SimpleTableCell>
              </SimpleTableRow>
            )}

            {!isLoading && (!topProducts || topProducts.length === 0) && (
              <SimpleTableRow>
                <SimpleTableCell colSpan={2}>
                  <div className="text-center mt-2 label-base">
                    <p>No top products data available for the selected collection.</p>
                  </div>
                </SimpleTableCell>
              </SimpleTableRow>
            )}

            {topProducts?.map((p, index) => {
              return (
                <SimpleTableRow key={p.name} className="border-none">
                  <SimpleTableCell>
                    {index + 1}. {p.name}
                  </SimpleTableCell>
                  <SimpleTableCell className="text-fg-subtle">
                    {formatNumber(p.value, 0)}
                  </SimpleTableCell>
                </SimpleTableRow>
              )
            })}
          </SimpleTableBody>
        </SimpleTable>
      </CardContent>
    </Card>
  )
}

export default TopProductsCard
